import EmptyCard from './EmptyCard';

export default EmptyCard;
